import { RoomId, roomId, RoomMixerId, roomMixerId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerStartedEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStartedEventVO.validationSchema()
  );

  constructor(readonly value: RoomMixerStartedEvent) {
    JsonSchemaValidator.assert(RoomMixerStartedEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "mixerId"],
      properties: {
        roomId,
        mixerId: roomMixerId
      },
      additionalProperties: false
    };
  }
}

interface RoomMixerStartedEvent {
  roomId: RoomId;
  mixerId: RoomMixerId;
}
